import * as React from 'react'
import * as styles from './ProgressBar.module.scss'
import * as cn from 'classnames'
import { ItemProgressBar } from 'DVWebNodeUtils';
import perlBoolean from '../../../../utils/perlBoolean';

interface ProgressBarProps {
  progress: ItemProgressBar
}

const ProgressBar = ({ progress }: ProgressBarProps) => (
  Boolean(progress) &&
  Boolean(progress.percentage) &&
  (<div className={cn(
    styles.ProgressBar,
    { [styles.live]: progress && perlBoolean(progress.isLive) })
  }>
    <div style={{ width: `${progress.percentage}%` }}></div>
  </div>)
)

export default ProgressBar
